import { AuthRolType } from "../../context";

export interface PermissionGuardProps {
  allowedRoles: AuthRolType[];
  children: React.ReactNode;
}

export const hasPermission = (
  userPermissions: AuthRolType[],
  allowedRoles: AuthRolType[]
): boolean => {
  return userPermissions.some((permission) =>
    allowedRoles.includes(permission)
  );
};